module.exports = __webpack_public_path__ + "static/media/icon-empty-circle.01fbbaf0.svg";